import { faInfoCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import type React from "react";
import UncontrolledTooltip from "../../../../components/Theme/tooltip";
import type { UploadDefinition } from "./GenericUploadPage";

// Generic over the row payload — UploadPreviewTable is shared with the
// wireless survey tab (UploadDefinition<WirelessSurveyTarget>), not just
// asset-register rows.
export const ErrorRowInfoTooltipIcon = (props: {
  item: UploadDefinition<unknown>;
  index: number;
}): React.ReactElement => {
  const { item, index } = props;

  const tooltipContent = (): string => {
    const errorLines = (item.errors ?? []).map((e) => `Error: ${e.error}`);
    const warningLines = (item.warnings ?? []).map(
      (w) => `Modified: ${w.warning}`,
    );
    return [...errorLines, ...warningLines].join("; ");
  };

  const hasErrors = !!item.errors && item.errors.length > 0;
  const hasWarnings = !!item.warnings && item.warnings.length > 0;

  return (
    <div key={index}>
      {(hasErrors || hasWarnings) && (
        <UncontrolledTooltip placement="right" message={tooltipContent()}>
          <FontAwesomeIcon icon={faInfoCircle} fixedWidth />
        </UncontrolledTooltip>
      )}
    </div>
  );
};
